import { FC, useEffect } from 'react';
import './ToastComponent.scss';
import { ButtonComponent } from '../ButtonComponent/ButtonComponent';

export interface ToastComponentProps {
	title: string;
	text: string;
	afterAction?: () => void;
	undoAction?: () => void;
	afterActionText?: string;
	undoActionText?: string;
	isMobile: boolean;
}

const ToastComponent: FC<ToastComponentProps> = ({
	title,
	text,
	afterAction,
	afterActionText,
	isMobile,
	undoAction,
	undoActionText
}) => {
	useEffect(() => {
		const toast = document.querySelector('.Toastify .toast-success') as HTMLElement;
		if (!toast) return;

		if (isMobile) {
			const handleMobileScroll = () => {
				toast.classList.toggle('scrolled', window.scrollY > 25);
			};

			handleMobileScroll(); // Run immediately to set correct state
			window.addEventListener('scroll', handleMobileScroll);
			return () => {
				window.removeEventListener('scroll', handleMobileScroll);
			};
		}
		//desktop and tablet
		let ticking = false;

		const getBaseOffset = () => {
			const width = window.innerWidth;
			if (width <= 992) return 72; // tablet
			return 80; // desktop
		};

		const updatePosition = () => {
			const scrollY = window.scrollY;
			const baseOffset = getBaseOffset();
			const offset = Math.max(0, baseOffset - scrollY);

			toast.style.transition = 'margin-top 0.3s ease-out';
			toast.style.marginTop = `${offset}px`;
			ticking = false;
		};

		const handleScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(updatePosition);
				ticking = true;
			}
		};

		//Run immediately to set correct position if already scrolled
		updatePosition();

		window.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleScroll);
		};
	}, [isMobile]);

	return (
		<div className='toast-body' style={{ width: !isMobile ? '450px' : '282px' }}>
			<h5 className='toast-title'>{title}</h5>
			<div className='toast-text'>{text}</div>
			{(afterAction || undoAction) && (
				<div className='toast-actions'>
					{afterAction && (
						<ButtonComponent
							text={afterActionText || 'Ok'}
							onClick={afterAction}
							style={'rounded-button secondary'}
						/>
					)}
					{undoAction && (
						<ButtonComponent
							text={undoActionText || 'Undo'}
							onClick={undoAction}
							style={'rounded-button tertiary'}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default ToastComponent;
